/**
 * 解析：AI业务流程建模支持JSON与JSON数组2种格式，需要分别处理
 * 
 * @param {*} content AI业务流程建模返回内容
 */
const parseAiBf = (wfListsJson) => {
    const reg = /\[(create|read|update|delete)\](.*)/;

    // 树形结构转换为json结构
    if (Array.isArray(wfListsJson)) {
        const root = wfListsJson[0]; // 获取：根节点
        const bfs = root.children; // 获取：子节点（业务流程）
        const wfLists = [];

        // 遍历：业务流程
        for (const bf of bfs) {
            const props = bf.props[0];
            const jobs = bf.children;

            const wfName = bf.name;
            const wfCode = props.value;
            const wfType = props.id;
            const wfArr = [];

            // 遍历：作业
            for (const job of jobs) {
                const title = job.name;
                const props = job.props[0];
                const type = job.id;
                const opr = props.value; // 数据操作
                const branch = job.children ? job.children.map(child => {
                    return {
                        label: child.name,
                        to: child.props ? child.props[0].to : undefined
                    }
                }) : undefined;

                const crudDatas = [];

                if (opr) {
                    // 同时支持中英文逗号
                    let oprList = opr.split(','); 

                    for (const _opr of oprList) {
                        let oprs = _opr.match(reg);

                        if (oprs && oprs.length == 3) {
                            crudDatas.push({ type: oprs[1], data: [oprs[2]] });
                        }
                    }
                }

                // 添加：作业
                wfArr.push({ title, type, ...props, crudDatas, branch });
            }


            // 添加：业务流程
            wfLists.push({ wfCode, wfName, wfType, wfArr });
        }

        return { wfLists };
    }

    return wfListsJson;
}

export default parseAiBf;